// Server-stored asset paths (tenant logos, uploads) are saved relative —
// "/public/tenants/logos/…". That only resolves when the page is served from
// the API origin; on a separate client origin (local dev :3000 → API :5000)
// the <img> 404s and shows its alt text. Prefix relative paths with the API
// base URL; absolute URLs pass through unchanged.
const baseUrl = (process.env.REACT_APP_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : '')).replace(/\/$/, '');

export function assetUrl(p) {
  if (!p) return p;
  if (/^(https?:|data:|blob:)/i.test(p)) return p;
  return `${baseUrl}${p.startsWith('/') ? '' : '/'}${p}`;
}

export default assetUrl;
